var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('div',{staticClass:"main__container container"},[(!_vm.isMobile)?[_c('Contacts'),_c('Chat')]:[(!_vm.isChatActive)?_c('Contacts'):_c('Chat')]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }